import { BitkitTabs } from '@bitrise/bitkit-v2';

import LogViewer from '@/components/LogViewer/LogViewer';

const TestOutputTab = ({ content }: { content: string }) => {
  return (
    <BitkitTabs.Content value="test_output" padding="16">
      <LogViewer
        content={content}
        stickyToolbarOffset="none"
        overflow="clip"
        borderRadius="4"
        outline="1px solid"
        outlineColor="border/regular"
      />
    </BitkitTabs.Content>
  );
};

export default TestOutputTab;
